const settings = {
  baseURL: "https://gw-search.netlify.app/",
  indices: [
    {
      title: "All Sites",
      index: "crawler_gateway_sites"
    }
    // {
    //   title: "GatewayPeople.com",
    //   index: "crawler_gatewaypeople"
    // },
    // {
    //   title: "Gateway Bookstore",
    //   index: "crawler_gatewaypeople_store"
    // },
    // {
    //   title: "Gateway Unity",
    //   index: "crawler_unity-website"
    // },
    // {
    //   title: "Devotionals",
    //   index: "crawler_gateway_devotions"
    // }
  ]
};

export default settings;
